"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
const export_file_util_1 = require("./utils/export-file.util");
class JSErrorsClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.formatDateWithTimezone = true;
    }
    getTopErrors(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/top-errors`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getErrorMetricsData(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/error-metrics`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getAggregatedErrorsInfo(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/aggregated-errors-info`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getCharts(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/charts`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getExportData(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v1/projects/${projectId}/js-errors/export-errors`;
            const response = yield this.executeRaw('post', url, request);
            const exportResponse = {
                buffer: response.data,
                filename: export_file_util_1.getFileNameFromContentDisposition(response.headers['content-disposition']),
                contentType: response.headers['content-type'],
            };
            return exportResponse;
        });
    }
    getErrorMetricsDataV2(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v2/projects/${projectId}/js-errors/error-metrics`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
    getAggregatedErrorsInfoV2(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const projectId = request.analysisContext.project;
            const url = `/v2/projects/${projectId}/js-errors/aggregated-errors-info`;
            const response = yield this.httpPost(url, request);
            return response.payload;
        });
    }
}
exports.JSErrorsClient = JSErrorsClient;
//# sourceMappingURL=js-errors.client.js.map